export function initFaqAccordion(selector = '#accordion-flush') {
  const accordion = document.querySelector(selector);
  if (!accordion) return;

  const buttons = accordion.querySelectorAll('button[data-accordion-target]');

  function updateState() {
    const expanded = accordion.querySelectorAll('button[aria-expanded="true"]');

    if (expanded.length === 0) {
      // Wszystkie czarne + strzałki w dół
      buttons.forEach((btn) => {
        btn.classList.remove('text-gray-500');
        btn.classList.add('text-gray-900');
        const icon = btn.querySelector('svg[data-accordion-icon]');
        if (icon) icon.classList.remove('rotate-180');
      });
    } else {
      // Otwarty czarny + strzałka w górę, reszta szare + strzałka w dół
      buttons.forEach((btn) => {
        const icon = btn.querySelector('svg[data-accordion-icon]');
        if (btn.getAttribute('aria-expanded') === 'true') {
          btn.classList.remove('text-gray-500');
          btn.classList.add('text-gray-900');
          if (icon) icon.classList.add('rotate-180');
        } else {
          btn.classList.remove('text-gray-900');
          btn.classList.add('text-gray-500');
          if (icon) icon.classList.remove('rotate-180');
        }
      });
    }
  }

  // Podłącz update przy kliknięciu
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(updateState, 50);
    });
  });

  // Startowy stan
  updateState();
}
